export const REWARD_TYPE = {
  BONUS_POINTS: 'A',
  BONUS_POINTS_CATEGORY: 'Bonus Points',
  FOOD_CREDIT: 'F',
  FREE_PLAY: 'P',
  FREE_PLAY_PRIZE_CATEGORY: 'G',
  SHOPPING_DOLLARS: 'shopping-dollars',
  SHOPPING_DOLLARS_CATEGORY: 'Shopping Dollars',
  HOTEL_STAY: 'R',
  HOTEL_STAY_PRIZE_CATEGORY: 'H',
  DRAWING_TICKET: 'DrawingTicket',
  DRAWING_TICKET_PRIZE_CATEGORY: 'D',
  SPA: 'S',
  SOFT_OFFER_CMP: 'CMP',
  WSCORE: 'WScore',
  WSCORE_PRIZE_CATEGORY: 'W',
  OF_NO_ACTION: 'OF - No Action',
  BATTLE_SLOTS: 'Battle Slots',
  BATTLE_SLOTS_PRIZE_CATEGORY: 'B',
  QUEST: 'Q',
  COUPON: 'U',
  CASINO_TICKET: 'K',
  WCFOOD_CREDIT: 'WCFoodCredit',
  TIERED_PRIZE: 'Tiered Prize',
  CV_CURRENCIES: 'CV Currencies',
  CASINO_DRAWINGS_CATEGORY: 'CASION_DRAWINGS',
  PARTNERS: 'Partners',
  UBER: 'Uber',
  DEFAULT: 'default'
};

export const UBER_EVENT_TYPE = {
  CLAIMED: 'voucher_program_code_claimed',
  REDEEMED: 'voucher_program_code_redeemed',
  DISTRIBUTED: 'voucher_program_code_distributed',
  UPDATED: 'voucher_program_updated',
  COMPLETED: 'voucher_program_completed',
  CREATED: 'voucher_program_created',
  ACTIVATED: 'voucher_program_activated',
  CANCELED: 'voucher_program_canceled',
  EXPIRED: 'voucher_program_expired'
};

export const UBER_REDEEMED_STATUS = [UBER_EVENT_TYPE.REDEEMED];

export const UBER_AVAILABLE_STATUS = [
  UBER_EVENT_TYPE.CLAIMED,
  UBER_EVENT_TYPE.CREATED
];

export function getRewardTitle(type) {
  const rewardTitleMap = {
    [REWARD_TYPE.BONUS_POINTS]: 'Bonus Points',
    [REWARD_TYPE.FOOD_CREDIT]: 'Food Credit',
    [REWARD_TYPE.FREE_PLAY]: 'Free Play',
    [REWARD_TYPE.SHOPPING_DOLLARS]: 'Shopping Dollars',
    [REWARD_TYPE.SPA]: 'Spa',
    [REWARD_TYPE.HOTEL_STAY]: 'Hotel Stay',
    [REWARD_TYPE.DRAWING_TICKET]: 'ONLINE ENTRIES',
    [REWARD_TYPE.DRAWING_TICKET_PRIZE_CATEGORY]: 'ONLINE ENTRIES',
    [REWARD_TYPE.WSCORE]: 'WScore',
    [REWARD_TYPE.CV_CURRENCIES]: 'CV Currencies',
    [REWARD_TYPE.OF_NO_ACTION]: 'OF - No Action',
    [REWARD_TYPE.BATTLE_SLOTS]: 'Battle Challenge',
    [REWARD_TYPE.BATTLE_SLOTS_PRIZE_CATEGORY]: 'Battle Challenge',
    [REWARD_TYPE.QUEST]: 'Quest',
    [REWARD_TYPE.COUPON]: 'Coupon',
    [REWARD_TYPE.CASINO_TICKET]: 'Casino Ticket',
    [REWARD_TYPE.CASINO_DRAWINGS_CATEGORY]: 'Casino Drawings',
    [REWARD_TYPE.WCFOOD_CREDIT]: 'WC Food Credit',
    [REWARD_TYPE.PARTNERS]: 'Partners',
    [REWARD_TYPE.DEFAULT]: 'Reward'
  };

  return rewardTitleMap[type] || rewardTitleMap[REWARD_TYPE.DEFAULT];
}

export function getRewardType(reward) {
  if (
    reward.isSoftOffer &&
    reward.prizeType === REWARD_TYPE.SOFT_OFFER_CMP &&
    reward.prize &&
    reward.prize.category
  ) {
    let prizeType = reward.prize.category.charAt(0).toString();
    if (reward.prize.category === REWARD_TYPE.CV_CURRENCIES) {
      return REWARD_TYPE.CV_CURRENCIES;
    } else if (prizeType === REWARD_TYPE.FREE_PLAY_PRIZE_CATEGORY) {
      return REWARD_TYPE.FREE_PLAY;
    } else if (prizeType === REWARD_TYPE.HOTEL_STAY_PRIZE_CATEGORY) {
      return REWARD_TYPE.HOTEL_STAY;
    } else if (prizeType === REWARD_TYPE.DRAWING_TICKET_PRIZE_CATEGORY) {
      return REWARD_TYPE.DRAWING_TICKET;
    } else if (
      prizeType === REWARD_TYPE.WSCORE_PRIZE_CATEGORY &&
      reward.prize.category !== REWARD_TYPE.WCFOOD_CREDIT
    ) {
      return REWARD_TYPE.WSCORE;
    } else if (
      reward.prize.category === REWARD_TYPE.SHOPPING_DOLLARS_CATEGORY
    ) {
      return REWARD_TYPE.SHOPPING_DOLLARS;
    } else if (reward.prize.category === REWARD_TYPE.BONUS_POINTS_CATEGORY) {
      return REWARD_TYPE.BONUS_POINTS;
    } else if (reward.prize.category === REWARD_TYPE.WCFOOD_CREDIT) {
      return REWARD_TYPE.WCFOOD_CREDIT;
    } else {
      return prizeType;
    }
  } else {
    return reward.prizeType;
  }
}

export const isStandardPrizeType = reward => {
  return reward.type !== REWARD_TYPE.SOFT_OFFER_CMP;
};

export const isRedeemed = reward => {
  return reward.redeemed >= reward.quantity;
};

export const isExpired = (reward, now = new Date()) => {
  return (
    reward.expired ||
    (!isRedeemed(reward) && now >= reward.endDate && !reward.canceled)
  );
};

export const isAvailable = (reward, now = new Date()) => {
  return (
    UBER_AVAILABLE_STATUS.includes(reward.eventType) ||
    (!isRedeemed(reward) && !isExpired(reward, now) && !reward.canceled)
  );
};

export const getStatus = (reward, now = new Date()) => {
  const { redeemed, quantity, endDate } = reward;
  if (redeemed && (redeemed === quantity || endDate < now)) {
    return 'Redeemed';
  }
  if (isExpired(reward)) {
    return 'Expired';
  }
  return '';
};
